import { render } from "./NcrmMailjetTemplatesTab.vue?vue&type=template&id=34695556&scoped=true"
import script from "./NcrmMailjetTemplatesTab.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetTemplatesTab.vue?vue&type=script&lang=js"

import "./NcrmMailjetTemplatesTab.vue?vue&type=style&index=0&id=34695556&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34695556"]])

export default __exports__